// @flow
import React, { useState, useEffect } from "react";
import { Button } from "@material-ui/core";
import InputField from "../../../components/ui/inputField";
import ValidatedDatePicker from "../../../components/ui/DatePicker";
import NumberFormat from "react-number-format";
import { ValidatorForm } from "react-material-ui-form-validator";
import { toast } from "react-toastify";

import axios from "../../../axios-order";
import style from "../BusinessEntityDetails.module.css";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

// Note: Ensure your local environment has these components or maps them correctly
export default function Add(props) {
  const { cancelAddForm, updateGetApi } = props;
  
  const [addTdsData, setAddTdsData] = useState({});
  const [fromDateToDisplay, setFromDateToDisplay] = useState(null);
  
  // --- New Logic State ---
  const [sectionDropdown, setSectionDropdown] = useState([]);
  const [sectionMapping, setSectionMapping] = useState([]); // Holds original API data
  const [sectionNewOptions, setSectionNewOptions] = useState([]); // Holds dependent options

  useEffect(() => {
    fetchSectionDropdown();
  }, []);

  const fetchSectionDropdown = () => {
    axios
      .get("/get_tds_section_dropdown")
      .then((res) => {
        const apiData = res.data.record || res.data;
        setSectionMapping(apiData);
        // Extract unique parent sections for the first dropdown
        setSectionDropdown(apiData);
      })
      .catch((err) => {
        console.error("Error fetching section dropdown:", err);
      });
  };

  const addInputChangeHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setAddTdsData({
      ...addTdsData,
      [name]: value,
    });
  };

  // UPDATED: Handle Section change and filter dependent options
  const handleSectionChange = (e) => {
    const selectedValue = e.target.value;
    
    // Find the object in our mapping that matches the selection
    const matched = sectionMapping.find(
        (item) => (item.id || item.code || item.section || item) === selectedValue
    );

    let dependentList = [];
    let autoSelectSubSection = "";

    if (matched && matched.section_new) {
        dependentList = matched.section_new;
        // Auto-select if there is only one child option
        if (dependentList.length === 1) {
            autoSelectSubSection = dependentList[0];
        }
    }

    setSectionNewOptions(dependentList);
    
    setAddTdsData({
      ...addTdsData,
      tds_section_as_per_certificate: selectedValue,
      section_new: autoSelectSubSection, // Clear or auto-fill sub-section
    });
  };

  const handleFromDateChange = (v) => {
    setFromDateToDisplay(v);
    setAddTdsData({
      ...addTdsData,
      valid_to_date: null,
    });
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();
      setAddTdsData({
        ...addTdsData,
        valid_from_date: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      });
    }
  };

  const handleToDateChange = (v) => {
    if (v != "Invalid Date" && v != null) {
      const pad = "00";
      const yy = v.getFullYear().toString();
      const mm = (v.getMonth() + 1).toString();
      const dd = v.getDate().toString();
      setAddTdsData({
        ...addTdsData,
        valid_to_date: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      });
    }
  };

  const finalAddData = {
    org_gstin: `${localStorage.getItem("gst")}`,
    records: [addTdsData],
  };

  const addFormsubmitHandler = (e) => {
    if (addTdsData.valid_to_date < addTdsData.valid_from_date) {
      alert("To Date is lesser than From date");
      return false;
    }
    if (!addTdsData.TDSType) {
      alert("Please Select the Sales or Purchase ");
      return false;
    }

    axios
      .post("/tds/ltds", finalAddData)
      .then((res) => {
        if (res.data.status === true) {
          cancelAddForm();
          updateGetApi();
          setAddTdsData({});
          setSectionNewOptions([]);
          toast.success(res.data.message, { autoClose: 2000 });
        } else {
          toast.error(res.data.message, { autoClose: 2000 });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const cancelAddFormDrawer = () => {
    setAddTdsData({});
    setSectionNewOptions([]);
    cancelAddForm();
  };

  return (
    <ValidatorForm
      onSubmit={addFormsubmitHandler}
      onError={(errors) => console.log(errors)}
    >
      <FormControl>
        <label style={{ marginBottom: "0px" }}>
          TDS Type<span style={{ color: "red" }}>*</span>
        </label>
        <RadioGroup
          row
          name="TDSType"
          value={addTdsData.TDSType ?? ""}
          onChange={addInputChangeHandler}
        >
          <FormControlLabel value="Sales" control={<Radio />} label="Sales" />
          <FormControlLabel value="Purchase" control={<Radio />} label="Purchase" />
          <FormControlLabel value="NRI" control={<Radio />} label="NRI" />
        </RadioGroup>
      </FormControl>

      <InputField
        textLabel={addTdsData.TDSType === "NRI" ? "Vendor Name" : "Legal Name"}
        inputType="text"
        name="vendor_legal_name"
        inputProps={{ maxLength: 100 }}
        requiredField="*"
        validator={["required"]}
        errorMsg={["This field is required"]}
        value={addTdsData.vendor_legal_name ?? ""}
        textOnchangeFunction={addInputChangeHandler}
      />

      {/* <InputField
        textLabel="Legal Name"
        inputType="text"
        name="vendor_legal_name"
        inputProps={{ maxLength: 100 }}
        requiredField="*"
        validator={["required"]}
        errorMsg={["This field is required"]}
        value={addTdsData.vendor_legal_name ?? ""}
        textOnchangeFunction={addInputChangeHandler}
      /> */}

      <InputField
        textLabel="PAN"
        inputType="text"
        name="pan"
        inputProps={{ maxLength: 10 }}
        value={addTdsData.pan ?? ""}
        requiredField="*"
        validator={["required"]}
        errorMsg={["This field is required"]}
        textOnchangeFunction={addInputChangeHandler}
      />

      <div style={{ marginTop: "20px" }}>
        <label>From Date <span style={{ color: "red" }}>*</span>:</label>
        <ValidatedDatePicker
          name="valid_from_date"
          value={addTdsData.valid_from_date ?? null}
          onChange={(v) => handleFromDateChange(v)}
          validators={["required"]}
          errorMessages={["This field is required"]}
        />
      </div>

      <div style={{ marginTop: "20px" }}>
        <label>To Date <span style={{ color: "red" }}>*</span>:</label>
        <ValidatedDatePicker
          minDateForDatepicker={addTdsData.valid_from_date ?? null}
          name="to_date"
          value={addTdsData.valid_to_date ?? null}
          onChange={(v) => handleToDateChange(v)}
          validators={["required"]}
          errorMessages={["This field is required"]}
          disabled={!fromDateToDisplay}
        />
      </div>

      <InputField
        textLabel="Certificate no for ltds"
        inputType="text"
        name="certificate_no_for_ltds"
        value={addTdsData.certificate_no_for_ltds ?? ""}
        requiredField="*"
        inputProps={{ maxLength: 10 }}
        validator={["required"]}
        errorMsg={["This field is required"]}
        textOnchangeFunction={addInputChangeHandler}
      />

      {/* Primary Section Dropdown */}
      <div style={{ marginTop: "20px" }}>
        <label>Section as per certificate <span style={{ color: "red" }}>*</span>:</label>
        <FormControl fullWidth style={{ marginTop: "8px" }}>
          <Select
            name="tds_section_as_per_certificate"
            value={addTdsData.tds_section_as_per_certificate ?? ""}
            onChange={handleSectionChange} // Updated handler
            style={{ height: "40px" }}
            displayEmpty
          >
            {sectionDropdown.map((item, index) => (
              <MenuItem key={index} value={item.id || item.code || item.section || item}>
                {item.name || item.description || item.section || item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {/* Dependent Section New Dropdown (Only shows if there are options) */}
      {sectionNewOptions.length > 0 && (
        <div style={{ marginTop: "20px" }}>
          <label>Section New <span style={{ color: "red" }}>*</span>:</label>
          <FormControl fullWidth style={{ marginTop: "8px" }}>
            <Select
              name="section_new"
              value={addTdsData.section_new ?? ""}
              onChange={addInputChangeHandler}
              style={{ height: "40px" }}
            >
              {sectionNewOptions.map((item, index) => (
                <MenuItem key={index} value={item}>{item}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      )}

      <InputField
        textLabel="Tds as per certificate"
        inputType="text"
        inputProps={{ maxLength: 10 }}
        name="tds_as_per_certificate"
        value={addTdsData.tds_as_per_certificate ?? ""}
        validator={[
          "matchRegexp:^([0]|[1-9][0-9]?|100)$|^[0-9]{0,2}.[0-9]{1,2}$",
          "maxFloat:100.00",
        ]}
        errorMsg={["invalid percentage.", "invalid percentage."]}
        textOnchangeFunction={addInputChangeHandler}
      />

      <div style={{ marginTop: "20px" }}>
        <label>₹ Limit amount<span style={{ color: "red" }}>*</span>:</label> <br />
        <NumberFormat
          className={style.numberFormate}
          style={{ paddingLeft: "10.5px" }}
          value={addTdsData.limit_amount ? addTdsData.limit_amount : ""}
          thousandsGroupStyle="lakh"
          prefix="₹"
          required
          decimalSeparator="."
          displayType="input"
          type="text"
          decimalScale={2}
          thousandSeparator={true}
          allowNegative={false}
          onValueChange={(values) => {
            const { value } = values;
            setAddTdsData({
              ...addTdsData,
              limit_amount: value === "" ? 0 : parseFloat(value),
            });
          }}
        />
      </div>

      <div className="mt-20">
        <button className="button-primary" type="submit">Submit</button>
        <button className="button-outlined-secondary" type="button" onClick={cancelAddFormDrawer}>cancel</button>
      </div>
    </ValidatorForm>
  );
}